import { LegalClientFinancialMonitoringEntity } from 'api/types/entity';
import { yesOrNot } from 'helpers';
import { TFunc } from 'libs/i18n';

import { CompanyGlobalFinancialMonitoringPartTwoFormType } from '../../forms/companyGlobalFinancialMonitoringPartTwoForm';

export const getInitialData = (
  t: TFunc,
  data?: LegalClientFinancialMonitoringEntity
): CompanyGlobalFinancialMonitoringPartTwoFormType => ({
  hasSourceOfFundsProcedures: yesOrNot(
    t,
    data?.globalInfo?.partTwo?.hasSourceOfFundsProcedures
  )!,

  hasRelationshipsWithPEPProcedures: yesOrNot(
    t,
    data?.globalInfo?.partTwo?.hasRelationshipsWithPEPProcedures
  )!,

  hasAnonymousAccounts: yesOrNot(
    t,
    data?.globalInfo?.partTwo?.hasAnonymousAccounts
  )!,
  hasAnonymousAccountPreventionProcedures: yesOrNot(
    t,
    data?.globalInfo?.partTwo?.hasAnonymousAccountPreventionProcedures
  )!,
  hasTransactionMonitoringProcedures: yesOrNot(
    t,
    data?.globalInfo?.partTwo?.hasTransactionMonitoringProcedures
  )!,
  hasAssetFreezingProcedures: yesOrNot(
    t,
    data?.globalInfo?.partTwo?.hasAssetFreezingProcedures
  )!,

  hasAMLTrainingProcedures: yesOrNot(
    t,
    data?.globalInfo?.partTwo?.hasAMLTrainingProcedures
  )!,
  amlTrainingDetails: data?.globalInfo?.partTwo?.amlTrainingDetails,

  hasBranchesInNonFATFCountries: yesOrNot(
    t,
    data?.globalInfo?.partTwo?.hasBranchesInNonFATFCountries
  )!,
  nonFATFBranchesNamesAndLocations:
    data?.globalInfo?.partTwo?.nonFATFBranchesNamesAndLocations,

  hasCorrespondentsInNonFATFCountries: yesOrNot(
    t,
    data?.globalInfo?.partTwo?.hasCorrespondentsInNonFATFCountries
  )!,
  nonFATFCorrespondentsNames:
    data?.globalInfo?.partTwo?.nonFATFCorrespondentsNames,

  hasCorrespondentsInOffshoreZones: yesOrNot(
    t,
    data?.globalInfo?.partTwo?.hasCorrespondentsInOffshoreZones
  )!,
  offshoreCorrespondentsNames:
    data?.globalInfo?.partTwo?.offshoreCorrespondentsNames,

  hasShellBankRelationships: yesOrNot(
    t,
    data?.globalInfo?.partTwo?.hasShellBankRelationships
  )!,
  shellBanksNames: data?.globalInfo?.partTwo?.shellBanksNames,

  hasShellBankPreventionProcedures: yesOrNot(
    t,
    data?.globalInfo?.partTwo?.hasShellBankPreventionProcedures
  )!,
  hasCDDRequestComplianceProcedures: yesOrNot(
    t,
    data?.globalInfo?.partTwo?.hasCDDRequestComplianceProcedures
  )!,

  creditRating: data?.globalInfo?.partTwo?.creditRating,
  subsidiariesNamesAndLocations:
    data?.globalInfo?.partTwo?.subsidiariesNamesAndLocations,
  keyPartnersNames: data?.globalInfo?.partTwo?.keyPartnersNames,
  foreignBranchesNamesAndLocations:
    data?.globalInfo?.partTwo?.foreignBranchesNamesAndLocations,
  financialGroupInfo: data?.globalInfo?.partTwo?.financialGroupInfo,

  hasSanctionPolicyDocuments: yesOrNot(
    t,
    data?.globalInfo?.partTwo?.hasSanctionPolicyDocuments
  )!,
  hasSanctionsMonitoringProcedures: yesOrNot(
    t,
    data?.globalInfo?.partTwo?.hasSanctionsMonitoringProcedures
  )!,
  isUnderSanctionsOrControlledBySanctionedEntity: yesOrNot(
    t,
    data?.globalInfo?.partTwo?.isUnderSanctionsOrControlledBySanctionedEntity
  )!,
  isListedInSanctionLists: yesOrNot(
    t,
    data?.globalInfo?.partTwo?.isListedInSanctionLists
  )!,
  isLinkedToSanctionedEntities: yesOrNot(
    t,
    data?.globalInfo?.partTwo?.isLinkedToSanctionedEntities
  )!,
});
